import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { formatDate, formatReviewPeriod, type DocumentReview } from "./helpers";
import { useText } from "./text";
import { WorkflowStepSwatch } from "./WorkflowStepSwatch";

export const DocumentReviewSummary = ({
  documentReview,
}: {
  documentReview: DocumentReview;
}) => {
  const { t } = useTranslation();
  const text = useText();
  const { entry, release } = documentReview;
  const version = t(($) => $.commons.workflow.versionOrder, {
    order: release.majorVersion,
  });

  return (
    <div className="flex flex-col gap-1">
      <div className="text-sm font-semibold">{entry.name}</div>
      <div className="text-muted-foreground">
        {`${version} · ${formatReviewPeriod(documentReview)} · ${t(($) => $.commons.workflow[release.status])}`}
      </div>
      <ul className="flex flex-col gap-0.5">
        {release.workflowSteps.map((workflowStep, order) => (
          <li key={workflowStep.name} className="flex items-center gap-1.5">
            <WorkflowStepSwatch order={order} />
            <span className="flex-1">{workflowStep.name}</span>
            <span className="text-muted-foreground whitespace-nowrap">
              {formatDate(workflowStep.dueAt, "dayMonth")}
            </span>
            <span className="flex size-3 items-center">
              {workflowStep.completedAt && (
                <Check
                  className="size-3"
                  aria-label={text.workflowStep.completed}
                />
              )}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
